<template>
    <div>
        <form class="form">
            <ui-select-v2
                v-model="selectGroup"
                label="Perfis:"
                item-label="label"
                :data="setGroupsToTypeGroups"
                return-value="value"
                group-by ='type'
                @input="setGroup"
            />
            <ui-select-v2
                v-if="['broker' ,'supervisor' ,'manager'].includes(selectGroup)"
                v-model="newTeam"
                :multiple="multiple"
                label="Equipe:"
                item-label="label"
                return-value="value"
                :data="dataTeams"
                :loading="loadTeams"
                open-event="change-profile-teams"
                ajax-search
                search-event="change-profile-teams"
                @input="selectedTeans"
            />
            <div v-if="errorTeam" class="msg">
                <div class="triangle"/>
                <div class="no-empty" @mouseleave="errorTeam = false" @click="errorTeam = false">
                    <div class="icom">
                        <i class="fas fa-exclamation" aria-hidden="true"/>
                    </div>
                    <div>
                        Selecione um item da lista.
                    </div>
                </div>
            </div>
            <div v-if="load" class="load">
                <ui-load-indicator
                    bg-color="#e7e9f4"
                    color="#69D296"
                    :h="30"
                    :stroke="5" />
            </div>
            <ui-select-v2
                v-if="managers && newTeam && !load"
                v-model="selectManager"
                :multiple="multiple"
                label="Gerente:"
                item-label="label"
                return-value="value"
                :data="managers"
                size="md"
                @input="selectedManager" />
            <div v-if="errorManager" class="msg" @mouseleave="errorManager = false" @click="errorManager = false">
                <div class="triangle"/>
                <div class="no-empty">
                    <div class="icom">
                        <i class="fas fa-exclamation" aria-hidden="true"/>
                    </div>
                    <div>
                        Selecione um item da lista.
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { uiLoadIndicator }  from '@/components/ui'
import { uiSelectV2       }  from '@/components/ui/form'
import { offline         }  from '@/services/axios'
export default {
    name: 'ui-form-users-edit',
    components: {
        uiLoadIndicator,
        uiSelectV2
    },

    props: {
        groups: {
            type: [Array, Object],
            default: () => {}
        },
        group: {
            type: String,
            default: ''
        },
        dataTeams: {
            type: Array,
            default: () => []
        },
        loadTeams: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            selectGroup: null,
            newTeam: null,
            selectManager: null,
            errorTeam: false,
            load: false,
            managers: [],
            multiple: false,
            errorManager: false,
            groupsIsSelected: {
                broker:         ['broker'],
                manager:        ['broker', 'manager'],
                supervisor:     ['broker', 'manager', 'supervisor'],
                admin:          ['broker', 'manager', 'supervisor','admin'],
                collaborator:   ['broker', 'manager', 'supervisor','collaborator'],
                all:            ['broker', 'manager', 'supervisor','collaborator', 'admin']
            }
        }
    },

    computed: {
        setGroupsToTypeGroups() {
            let group = this.groups
            if(this.groupsIsSelected.all.includes(this.group)) {
                group = this.groups.filter(item => !this.groupsIsSelected[this.group].includes(item.value) && item.type ==='Perfis do Sistema')
            } else {
                group = this.groups.filter(item => item.type === 'Perfis Dinâmicos')
            }
            return group
        }
    },

    methods: {
        selectedManager () {
            this.$emit('imput', {group: this.selectGroup, manager: this.selectManager, team: this.newTeam})
        },

        //ativa o botão de atualização do usuário se for gerente ou supervisor
        selectedTeans (a) {
            if (this.selectGroup == 'broker' && a) {
                this.load = true
                offline.getManagerByTeam(a).then(res => {
                    this.managers = []
                    res.data.forEach(element => {
                        this.managers.push({value: element.manager_id, label: element.first_name, id: element.id})
                    });
                    this.load = false
                })
            } else {
                if (this.selectGroup == 'admin' || this.selectGroup == 'collaborator') {
                    this.$emit('desactive', 'save', false)
                }
                else {
                    this.$emit('imput', {group: this.selectGroup, team: this.newTeam, manager: null})

                }
                this.managers = null
                this.load = false
            }
            if (a && a.length == 0) {
                return this.$emit('desactive', 'save', true)
            }
        },

        //ativa o botão de atualização do usuário se for corretor
        setGroup(group) {
            this.newTeam = null
            if (group == 'manager' || group == 'broker' || group == 'supervisor') {
                this.multiple = group == 'supervisor' ? true : false
                return this.$emit('desactive', 'save', true)
            } else {
                this.$emit('imput', {group: this.selectGroup, team: null, manager: null})
                this.newTeam = null
            }
            if(group != "admin" && group !="manager" && group !="supervisor" && group !="broker" && group !="collaborator" ) {
                return this.$emit('desactive', 'save', false)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>